<dialog *ngIf="displayUpgradeNotice" class="upgrade-notice alert alert-warning shadow">
  <strong class="warning-message">
    <h3
      [appI18n]="{
        code: 'browserUpgradeNotice.message.actionRequired',
        default: 'ACTION REQUIRED: You have been identified as accessing this site from a browser that will soon be no longer supported.'
      }"
    ></h3>
    <p
      [appI18n]="{
        code: 'browserUpgradeNotice.message.upgradeRequest',
        default:
          'To continue accessing this site you will need to update your browser. If you are accessing from your organisation’s network, please contact your IT Team to request that your network is updated to be compliant.'
      }"
    ></p>
    <span class="d-flex align-items-center">
      <p
        [appI18n]="{
          code: 'browserUpgradeNotice.message.supportedBrowsers',
          default: ' Please see below for a list of supported browsers: '
        }"
      ></p>
      <small
        >(Detected Browser: {{ browserInformation?.title.label }}: version {{ browserInformation?.version.major }}.{{
          browserInformation?.version.minor
        }}).
      </small></span
    >
  </strong>

  <span class="google-icon close notranslate" (click)="dismissWarning()">close</span>

  <ul>
    <li *ngFor="let browser of supportedBrowserList" class="supported-browser">
      <a [href]="">{{ browser.label }}:</a>
      <small
        >Version {{ supportedVersionList[browser.userAgentLookup]?.major }}.{{ supportedVersionList[browser.userAgentLookup]?.minor }}</small
      >
    </li>
  </ul>

  <a class="download-link" [href]="browserInformation?.download" target="_blank"
    ><span
      [appI18n]="{ code: 'browserUpgradeNotice.browserLatestVersionDownload', default: 'Click here to download the latest version of' }"
    ></span>
    {{ browserInformation?.title.label }}
  </a>
</dialog>
